export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes/`;
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '34b50a39-018b-4d0a-aaea-b4796d70bcec';
export const MODAL_CLOSE_SEC = 2.5;
